import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { mapTalents } from './../../utils/talents.utils';
import { SEARCH_TALENT_CAROUSEL_DEFAULT_BREAKPOINTS } from './constants';
import { setTalentInfo } from './../../redux/actions/talent.actions';
import { getRegion } from 'utils/Region';
//-------------------------------------------------------------------------------------------
import SearchResultCard from '../SearchResultCard';
import TalentsCarousel from '../../../../components/TalentsCarousel';
import { ErrorMessage } from './ErrorMessage';
import './style.scss';
import { useFilterContentForKid } from './hooks/useFilterContentForKid';
import ErrorMessageKid from '../NotFoundSearchResults/components/ErrorMessageNotFoundForKid';
import {
  setErrorLinealPredictive,
  setKeywordSearch,
} from '../../redux/actions/searchActions';
import ThreeDotsLoader from './componets/ThreeDotsLoader';
import MediaQuery from 'react-responsive';
import { getTranslation, jsonParseCatch } from 'utils/getTranslation';
import { clearTalentFilterInfo } from 'containers/NewSearchTalentPage/Redux/actions/talentResultAction';
import { NOT_FOUND_SEARCH_RESULTS } from 'containers/NewSearchPage/redux/constants';
import { useNavigate } from 'react-router-dom';

//Este componente es el Grid de resultados de la busqueda ya sea, vod, live o talentos
//value hace referencia al searchValue del input
const SearchResultsContainer = ({ value }) => {
  const dispatch = useDispatch();
  const { popular, contenidos, talentos, notFoundResults } = useSelector(
    state => state.search.searchResults,
  );
  const isLoadingSearch = useSelector(
    state => state.search.searchResults.isLoading,
  );
  const errorsLinealPredictive = useSelector(
    state => state.search.searchResults.errorSearch,
  );
  const texts = useSelector(state => state.metadata.translations);
  const parseTranslation = jsonParseCatch(texts)?.language?.[getRegion()];
  const navigate = useNavigate();
  const textPopular = getTranslation(
    'popularSearches_default_title_label',
    parseTranslation,
  );
  const textResult = getTranslation(
    'resultSearches_default_title_label',
    parseTranslation,
  );

  const isNotAvailableForKid =
    errorsLinealPredictive?.[0]?.code === 'BYR_PAR_00005' ||
    errorsLinealPredictive?.[0]?.code === 'BYR_PAR_00006';
  const isNotFoundContentForKids =
    notFoundResults?.type === 'failureService' &&
    contenidos?.length === 0 &&
    isNotAvailableForKid === true;

  //Acciones que se disparan cuando se selecciona un talento del carousel de talentos
  const handleTalentClick = (talentId, internalId) => {
    const talentSelected = talentos?.find(talent => talent?.id === talentId);
    const talentName = `${talentSelected?.first_name} ${
      talentSelected?.last_name
    }`;
    const rolesFromTalent = talentSelected?.search_roles;
    window.scrollTo(0, 0);
    //RETORNAR SI TALENT ES NULL O UNDIFINED
    if (talentId === null || talentId === undefined) return;
    dispatch(clearTalentFilterInfo());
    //SETEAR LA KEYWORD
    dispatch(setKeywordSearch(value));
    //SETEAR EL TALENTO Y DIRIGUIR A LA PAGE DE TALENTO
    dispatch(setTalentInfo(talentId));
    navigate(
      `/${getRegion()}/talent/${talentId}?name=${encodeURIComponent(
        talentName,
      )}&&roles=${JSON.stringify(rolesFromTalent)}`,
    );
  };
  useEffect(() => {
    return () => {
      dispatch(setErrorLinealPredictive([]));
      dispatch({
        type: NOT_FOUND_SEARCH_RESULTS,
        payload: { status: false, type: '' },
      });
    };
  }, []);

  const renderTitleFromSearch = ()=>{
    return( <h2
      className="search-results__title"
      style={{ marginBottom: `${notFoundResults && 16}` }}
    >
      {value.length === 0 ||
      (notFoundResults.type === 'failureService' && !isNotAvailableForKid)
        ? textPopular
        : textResult}
    </h2>)

  }

  return (
    <div className="search-results">
      <MediaQuery maxWidth={'551px'} >
        {renderTitleFromSearch()}
      </MediaQuery>
      <div className="search-results__container">
        <MediaQuery minWidth={'552px'}>
          {renderTitleFromSearch()}
        </MediaQuery>

        <MediaQuery maxWidth={'551px'}>
          {isLoadingSearch && <ThreeDotsLoader />}
        </MediaQuery>
        {notFoundResults?.status === true && isNotAvailableForKid === false && (
          <ErrorMessage value={value} />
        )}
        {isNotFoundContentForKids === true && value?.length > 0 && (
          <ErrorMessageKid
            isNotFoundContentForKids={isNotFoundContentForKids}
            code={errorsLinealPredictive?.[0]?.code}
            value={value}
          />
        )}

        {value.length === 0 ||
        notFoundResults?.status === true ||
        isNotFoundContentForKids === true
          ? popular?.map(popularItem => (
              <SearchResultCard
                key={popularItem?.id}
                contentInfo={popularItem}
                isPopularSearch={true}
              />
            ))
          : contenidos?.map(contentItem => (
            <React.Fragment>
              <SearchResultCard
                value={value}
                key={`${contentItem?.id}`}
                contentInfo={contentItem}
                isPopularSearch={false}
              />
            </React.Fragment>
            ))}
        {/*<----Contenidos----*/}
      </div>
      {talentos?.length > 0 && value.length > 0 && (
        <TalentsCarousel
          talents={mapTalents(talentos)}
          breakpointConfig={SEARCH_TALENT_CAROUSEL_DEFAULT_BREAKPOINTS}
          onTalentClick={handleTalentClick}
        />
      )}
      {/*<----Talentos----*/}
    </div>
  );
};

SearchResultsContainer.propTypes = {
  value: PropTypes.string.isRequired,
};

export default SearchResultsContainer;
